import * as ambassadorWixEnterpriseWebFiveV1Icon from './enterprise-web-five-v1-icon-icons.http.js';
import * as ambassadorWixEnterpriseWebFiveV1IconTypes from './enterprise-web-five-v1-icon-icons.types.js';
import * as ambassadorWixEnterpriseWebFiveV1IconUniversalTypes from './enterprise-web-five-v1-icon-icons.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createIcon(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.CreateIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.CreateIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.CreateIconResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.CreateIconResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.createIcon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/icons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getIcon(): __PublicMethodMetaInfo<
  'GET',
  { iconId: string },
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.GetIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.GetIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.GetIconResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.GetIconResponse
> {
  const payload = { iconId: ':iconId' } as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.getIcon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/icons/{iconId}',
    pathParams: { iconId: 'iconId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateIconMetadata(): __PublicMethodMetaInfo<
  'PATCH',
  { iconId: string },
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.UpdateIconMetadataRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.UpdateIconMetadataRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.UpdateIconMetadataResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.UpdateIconMetadataResponse
> {
  const payload = { icon: { id: ':iconId' } } as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.updateIconMetadata(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/icons/{icon.id}',
    pathParams: { iconId: 'iconId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteIcon(): __PublicMethodMetaInfo<
  'DELETE',
  { iconId: string },
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.DeleteIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.DeleteIconRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.DeleteIconResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.DeleteIconResponse
> {
  const payload = { iconId: ':iconId' } as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.deleteIcon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/icons/{iconId}',
    pathParams: { iconId: 'iconId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchIcons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.SearchIconsRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.SearchIconsRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.SearchIconsResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.SearchIconsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.searchIcons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/icons/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateIconTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkUpdateIconTagsRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkUpdateIconTagsRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkUpdateIconTagsResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkUpdateIconTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.bulkUpdateIconTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/icons/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateIconTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkUpdateIconTagsByFilterRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkUpdateIconTagsByFilterRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkUpdateIconTagsByFilterResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkUpdateIconTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.bulkUpdateIconTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/icons/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkSeedIcons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkSeedIconsRequest,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkSeedIconsRequest,
  ambassadorWixEnterpriseWebFiveV1IconUniversalTypes.BulkSeedIconsResponse,
  ambassadorWixEnterpriseWebFiveV1IconTypes.BulkSeedIconsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEnterpriseWebFiveV1Icon.bulkSeedIcons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/internal/icons/bulk-seed',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Icon as IconOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  IconTagsModified as IconTagsModifiedOriginal,
  CreateIconRequest as CreateIconRequestOriginal,
  CreateIconResponse as CreateIconResponseOriginal,
  GetIconRequest as GetIconRequestOriginal,
  GetIconResponse as GetIconResponseOriginal,
  UpdateIconMetadataRequest as UpdateIconMetadataRequestOriginal,
  UpdateIconMetadataResponse as UpdateIconMetadataResponseOriginal,
  DeleteIconRequest as DeleteIconRequestOriginal,
  DeleteIconResponse as DeleteIconResponseOriginal,
  SearchIconsRequest as SearchIconsRequestOriginal,
  IconFilter as IconFilterOriginal,
  TenantScope as TenantScopeOriginal,
  TenantScopeWithLiterals as TenantScopeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  SearchIconsResponse as SearchIconsResponseOriginal,
  SearchedIcon as SearchedIconOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdateIconTagsRequest as BulkUpdateIconTagsRequestOriginal,
  BulkUpdateIconTagsResponse as BulkUpdateIconTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateIconTagsResult as BulkUpdateIconTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateIconTagsByFilterRequest as BulkUpdateIconTagsByFilterRequestOriginal,
  BulkUpdateIconTagsByFilterResponse as BulkUpdateIconTagsByFilterResponseOriginal,
  BulkSeedIconsRequest as BulkSeedIconsRequestOriginal,
  SeedItem as SeedItemOriginal,
  SeedItemSourceOneOf as SeedItemSourceOneOfOriginal,
  BulkSeedIconsResponse as BulkSeedIconsResponseOriginal,
  SeedResult as SeedResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateIconTagsApplicationErrors as BulkUpdateIconTagsApplicationErrorsOriginal,
  BulkUpdateIconTagsByFilterApplicationErrors as BulkUpdateIconTagsByFilterApplicationErrorsOriginal,
} from './enterprise-web-five-v1-icon-icons.types.js';
